// Import your icons

import { Warehouse } from '@phosphor-icons/react/dist/ssr';
import * as React from 'react';

import { cn } from '@skrym/shared/utils/cn';

import { getOrganizationAssets } from '../utils/organizations';

export interface OrganizationIconProps extends React.SVGProps<SVGSVGElement> {
  organization: string; // run against both names/codes and id:s
}

const OrganizationIcon = React.forwardRef<SVGSVGElement, OrganizationIconProps>(
  ({ className, organization, ...props }, ref) => {
    let IconComponent: React.FC<React.SVGProps<SVGSVGElement>>;

    // find the organization where the organizationId or organizationName matches the organization prop
    const organizationAsset = getOrganizationAssets(organization);

    if (organizationAsset) {
      IconComponent = organizationAsset.icon;
    } else {
      IconComponent = Warehouse;
    }

    return <IconComponent ref={ref} className={cn(className)} {...props} />;
  },
);

OrganizationIcon.displayName = 'OrganizationIcon';

export { OrganizationIcon };
